let baseUrl = '',		//api地址
    h5BaseUrl = '',		//h5地址
    pointsBaseUrl = '';

const appEnv = process.env.VUE_APP_ENV || process.env.NODE_ENV

if (appEnv === 'development') {   //开发环境（在本地调试测试bug以后请将url切换为开发环境的dev在提交推送）
    //baseUrl = 'http://api.dev.dangjia.com/'   //开发
    //baseUrl = 'http://test-api.fengjiangit.com:28001/'   //测试
    //  baseUrl = 'https://uat-api.fengjiangit.com:48008/'   //uat
      baseUrl = 'https://api.fengjiangit.com/'
    h5BaseUrl = 'http://h5.dev.dangjia.com:8004/'		//开发
    pointsBaseUrl= 'http://10.10.10.8:8021/'
    
} else if (appEnv === 'test') {   //测试环境
    baseUrl = 'http://test-api.fengjiangit.com:28001/'   //测试
    h5BaseUrl = 'http://test-m.fengjiangit.com:8007/'	//测试
    pointsBaseUrl= 'http://test-points.fengjiangit.com:8022/'
} else if (appEnv === 'uat') {    //高保真环境
    baseUrl = 'https://uat-api.fengjiangit.com:48008/'   //uat
    h5BaseUrl = 'https://uat-m.fengjiangit.com:8015/'	//uat
    pointsBaseUrl= 'http://uat-points.fengiiangit.com:8023/'
} else if (appEnv === 'production') {
    baseUrl = 'https://api.fengjiangit.com/'
    h5BaseUrl = 'https://m.fengjiangit.com/' 
    pointsBaseUrl= 'https://points.fengjiangit.com/'
    console.log = () => { } //重写console方法 清除输出
}


export { baseUrl, h5BaseUrl,pointsBaseUrl }

